<template>
  <div id="attivitaAperto">
    <main-slider v-bind:page-height="pageHeight/2"></main-slider>
    <div id="scatola"   v-bind:style="{'min-height': pageHeight/3 + 'px'}">
      <div class="col-lg-12 indirizzo"><router-link :to="{name: 'homepage'}">
        Home</router-link> / <router-link :to="{name: 'attivita'}">{{$t("activiti")}}</router-link> / {{$t("courses")}}
        <div v-if="activities.length === 0" class="no-activites">{{$t("noCourses")}}</div>
      </div>
      <div v-for="(attivita, index) in activities" class="row box" v-bind:key="index">
        <div class="col-xl-6 col-lg-12 foto" style="background-size: cover" v-bind:style='{ backgroundImage: "url(static/image/attivita/" + attivita.imageact + ")", }'><!--img :src="'static/image/attivita/'+attivita.imageact" class="image">--></div>
        <div class="col-xl-6 col-lg-12 titoloevento">
          <span>{{attivita.title}}</span><br>
          <div class="descrizioneevento" v-html="attivita.shortDesc"></div>
          <b-btn class="informazioni" :to="{name: 'attivitaregistrazione', params: {id: attivita.id, language: attivita.language}}">{{$t("info")}}</b-btn>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
  import MainSlider from './MainSlider'
  import Footer from './Footer'
  export default {
    name: 'attivitaaperto',
    components: {Footer, MainSlider},
    data () {
      return {
        scrittaCarousel: 800,
        pageHeight: window.innerHeight,
        activities: []
      }
    },
    i18n: {
      fallbackLocale: 'it', // default lang,
      messages: {
        it: {
          courses: 'Attività all\' aperto',
          activiti: 'Attività',
          info: 'Maggiori Informazioni',
          noCourses:'Non sono presenti attività all\'aperto programmate al momento'
        },
        en: {
          courses: 'Outdoor Activities',
          activiti: 'Activities',
          info: 'More Information',
          noCourses:'There are no outdoor activites at the moment.'
        }
      }
    },
    beforeMount: function (){
      this.getActivitiesByCategory()
    },
    updated: function () {
      window.addEventListener('resize', this.getPageHeight)
    },
    mounted: function () {
      window.scroll(0, 0)
      window.addEventListener('resize', this.getPageHeight)
      this.getPageHeight()
    },
    methods: {
      getActivitiesByCategory: function () {
        let lang = this.$root.$i18n.locale === 'it' ? 'ita' : 'eng'
        this.$http.get('/ws-booking/activities/category/' + this.$route.params.catAttivita, {params: {lang: lang}}).then(response => {
          if (response.body.rc === 0) {
            this.activities = response.body.data
          }
        })
      },
      getPageHeight: function (event) {
        this.myHeight = window.innerHeight
        this.scrittaCarousel = this.myHeight - 150
      }
    }
  }
</script>

<style lang="less">
  @import "../assets/less/variabili.less";
  @import "../assets/less/font.less";

  #attivitaAperto {
    background-color: @lightBlack;
    #scatola {
      border-bottom: 1px solid darkgray;
      .indirizzo {
        padding-left: 125px;
        padding-top: 50px;
        letter-spacing: 1px;
        .set-font()
      }
      .box {
        border: 1px solid white;
        padding-left: 0px;
        width: 85%;
        margin: 40px auto;
        .foto {
          padding-left: 0px;
          .image {
            width: 100%;
            height: 100%;
          }
        }
        .titoloevento {
          padding-left: 80px;
          padding-top: 40px;
          .set-font-title()
        }
        .descrizioneevento {
          padding-top: 20px;
          padding-bottom: 50px;
          .set-font()
        }
        .informazioni {
          width: 230px;
          background-color: @myOrange;
          border-color: @borderOrange;
          margin: auto;
          text-align: center;
          display: inherit;
          letter-spacing: 1px;
          margin-bottom: 30px;
          .set-font()
        }
      }
    }
  }

  @media (max-width: 767px) {
    #attivitaAperto {
      #scatola {
        .indirizzo {
          padding-left: 20px;
          padding-top: 15px;
          letter-spacing: 1px;
          .set-font(@size: 13px)
        }
        .box {
          .foto {
            height: 150px;
            .image {
            }
          }
          .titoloevento {
            padding-left: 5px;
            padding-top: 10px;
            .set-font-title(@size: 25px)
          }
          .descrizioneevento {
            padding-bottom: 25px;
            padding-top: 15px;
            .set-font(@size: 14px)
          }
          .informazioni {
            padding-left: 3px;
            padding-right: 3px;
            margin-bottom: 15px;
            .set-font(@size: 13px);
            .info {
              padding-left: 5px;
              padding-right: 5px;
              .set-font(@size: 13px, @color: @lightGold)
            }
          }
        }
      }
    }
  }

  @media (min-width: 768px) and (max-width: 1024px) {
    #attivitaAperto {
      #scatola {
        .indirizzo {
        }
        .box {
          .foto {
            .image {
              width: 102%;
            }
          }
          .titoloevento {
            padding-left: 35px;
          }
          .descrizioneevento {
          }
          .informazioni {
            .info {
            }
          }
        }
      }
    }
  }

  @media (min-width: 1025px) and (max-width: 1366px) {
    #attivitaAperto {
      #scatola {
        .indirizzo {
        }
        .box {
          .foto {
          }
          .titoloevento {
          }
          .descrizioneevento {
          }
          .informazioni {
            .info {
            }
          }
        }
      }
    }
  }

  @media (min-width: 768px) {
    #attivitaAperto {
      #scatola {
        .indirizzo {
        }
        .box {
          .foto {
          }
          .titoloevento {
          }
          .descrizioneevento {
          }
          .informazioni {
            .info {
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/AttivitaAperto.vue